/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { StyledPropertyCardPriceDiv } from './index.style';
import { SearchResultDataNode, SearchStateStoreDataType } from '../../organisms/SearchResults/store/store.type';
import {
  DefaultValue,
  hardCodedAllLocale,
  STATUS_MAX_OCCUPANCY_EXCEEDED,
  STATUS_NOT_AVAILABLE,
} from '../../organisms/SearchResults/index.constant';
import { useConditionalSearchResultAlertContextSERP } from '../../hooks/lib/useConditionalSearchResultAlertContext';
import {
  getAlertsData,
  getCurrentPointSaversRateBlock,
  getCurrentPriceRateBlock,
  getCurrentRatePointsBlock,
  getCurrRateAmountBlock,
  getCurrentRateStrikeThroughBlock,
  getPriceByDecimalPoint,
  getPriceCommaSeparator,
  checkThresholdPercentage,
  updateDatalayerObjViewRates,
  getRateBlock,
} from '../../organisms/SearchResults/lib/helper';
import CommonUtils from '../../organisms/SearchResults/lib/CommonUtils';
import clsx from 'clsx';
import { useConditionalPageContextSERP } from '../../hooks';
import { useCheckBreakpoint } from '../../hooks/lib/useCheckBreakpoint';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { addSubDirectoryPrefix, fetchCurrencyToLocale } from '../../utils/src/helper';
import SM from '../../organisms/HotelGalleryTitle/config';
import {
  constructToolTipData,
  identifyTypeOfMandatoryFee,
  mandatoryFeeAvailable,
  mandatoryFeeDescriptionForPoints,
  resolveMonetaryDisplayBlock,
  resolveTotalPriceBlock,
} from '../../modules/utils/ratesHelper';
import { buildChatAvailabilityUrl as buildChatAvailabilityUrlUtil } from '../../modules/utils';
import { useSearchResultsStore } from '../../modules/store/searchResultsStore';
import { useConditionalSearchResultContextSERP } from '../../hooks/lib/useConditionalSearchResultContext';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
import { buildPriceLinkHref, isDePointsSection } from './helpers/propertyCardPriceHelpers';
import { PropertyCardPriceLink } from './components/PropertyCardPriceLink';
import { PointsMandatoryFeeSection } from './components/PointsMandatoryFeeSection';
import { StrikeThroughPriceDisplay } from './components/StrikeThroughPriceDisplay';
import { TaxesAndFeesIncludedLabel } from './components/TaxesAndFeesIncludedLabel';

export const PropertyCardPriceSection: React.FC<{
  propertyCardData: SearchResultDataNode;
  searchQueryContextValue?: SearchStateStoreDataType;
  staticDataContextValue?: any;
  fromHotelCard?: boolean;
  flexibleSearch?: boolean;
  isSpecialRateSearch?: boolean;
  flexibleOrManyProperty?: boolean;
  recentlyviewedRibbon?: (recentlyViewed: any, setRecentlyViewed: any, id: string) => void;
  setShowStrikeThroughPrice: (flag: boolean) => void;
  showStrikeThroughPrice: boolean;
  setFinalPrice?: (val: string) => void;
  currentLocaleLang?: string;
  HQVSelectedCurrency?: string;
  HQVRateConversionArr?: any;
  HQVRateBlockFlag?: boolean;
  HQVRateReqTypes?: any;
  HQVTaxesandFeeFlag?: boolean;
  miniPropertyCard?: boolean;
  pageNumber?: number;
  idx?: number;
  handleTooltipClick?: any;
  toolTipList?: any;
}> = ({
  propertyCardData,
  staticDataContextValue,
  searchQueryContextValue,
  fromHotelCard,
  flexibleSearch,
  isSpecialRateSearch,
  flexibleOrManyProperty,
  recentlyviewedRibbon,
  setShowStrikeThroughPrice,
  showStrikeThroughPrice,
  setFinalPrice,
  currentLocaleLang,
  HQVSelectedCurrency,
  HQVRateConversionArr,
  HQVRateBlockFlag,
  HQVRateReqTypes,
  HQVTaxesandFeeFlag,
  miniPropertyCard,
  pageNumber,
  idx,
  handleTooltipClick,
  toolTipList,
}) => {
  const {
    jsonContent,
    isErrorState,
    setIsErrorState,
    isMapViewEnabled,
    isFlexibleDateSearch,
    recentlyViewed,
    setRecentlyViewed,
  }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const { searchQueryState } = useConditionalSearchFilterContextWithSerpFlag();
  const { searchResult } = useConditionalSearchResultContextSERP();
  const { searchResultAlerts, setSearchResultAlerts } = useConditionalSearchResultAlertContextSERP();
  const { currentLocale, NEXT_PUBLIC_AVAILABILITY_SEARCH_URL, sessionData, pageVal } = useConditionalPageContextSERP();
  const sessionDataValuesOuter = useSearchResultsStore((state: { sessionDataValues: any }) => state.sessionDataValues);
  const chatSearchCriteria =
    sessionDataValuesOuter?.chatSearchCriteria ?? sessionDataValuesOuter?.sessionDataValues?.chatSearchCriteria;
  const staticContent = staticDataContextValue ?? jsonContent;
  const searchState = searchQueryContextValue ?? searchQueryState;
  const currentLocaleVal = currentLocaleLang ?? currentLocale;
  const isLocaleAllowed = SM?.ALLOWED_DOMAINS?.includes(currentLocale as string);
  const isShowFullPriceFromSession =
    searchState?.includeTaxesAndFees ||
    (sessionData?.data
      ? sessionData?.data?.AriesSearch?.searchCriteria?.showFullPrice === 'true'
        ? true
        : false
      : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.showFullPrice === 'true'
      ? true
      : false);
  const isShowFullPrice = pageVal === 'chat' ? Boolean(HQVTaxesandFeeFlag) : isShowFullPriceFromSession;
  const currentViewIsTab = CommonUtils.isTabletView();
  const currentViewIsMobile = CommonUtils.isOnlyMobileView();
  const currentViewIsDesktop = CommonUtils.isDesktopView();
  const clickTrackingLoc = 'Phoenix Search Results';
  const propertyID = propertyCardData?.node?.property?.id ?? '';
  const currRatePointsBlock = getRateBlock(propertyCardData?.node?.rates, 'points');
  const currRateNode = HQVRateBlockFlag
    ? getCurrentPriceRateBlock(HQVRateReqTypes, propertyCardData?.node?.rates)
    : getCurrentPriceRateBlock(searchState, propertyCardData?.node?.rates);
  const currRate = getCurrRateAmountBlock(currRateNode);
  const mandatoryFeeRates = currRate?.mandatoryFees;

  const currPointsRate = getCurrentRatePointsBlock(propertyCardData?.node?.rates);
  const currEliteDiscountRate = getCurrentRateStrikeThroughBlock(propertyCardData?.node?.rates);
  const currPointSaversNode = getCurrentPointSaversRateBlock(propertyCardData?.node?.rates);
  const isViewportL = useCheckBreakpoint('viewportL');

  const pointsValue = flexibleOrManyProperty ? null : currPointsRate?.points ?? null;
  const pointsLabelLength = staticContent?.pointsPerStayLabel?.length ?? 0;
  const pointsDisplayValueLength = (pointsValue?.toString().length ?? 0) + pointsLabelLength;

  const isPointsExceeds = pointsValue
    ? !currentViewIsMobile
      ? pointsValue?.toString().length > 6
        ? true
        : false
      : pointsDisplayValueLength > 14
      ? true
      : false
    : false;

  const isDeMapListSection = () =>
    isDePointsSection(currentLocaleVal, hardCodedAllLocale.de, miniPropertyCard, isMapViewEnabled, true);
  const isDePointsLayout = () =>
    isDePointsSection(currentLocaleVal, hardCodedAllLocale.de, miniPropertyCard, isMapViewEnabled, false);

  const { currentCurrency } = searchState;
  const selectedCurrency = HQVSelectedCurrency || currentCurrency;
  const suppressDisplay = Boolean(flexibleOrManyProperty);

  let priceInfo = resolveMonetaryDisplayBlock(currRate, isLocaleAllowed, suppressDisplay);
  let totalPrice = resolveTotalPriceBlock(currRate, isShowFullPrice, suppressDisplay);

  let EEOPriceInfo = resolveMonetaryDisplayBlock(currEliteDiscountRate, isLocaleAllowed, suppressDisplay);
  let EEOTotalPrice = resolveTotalPriceBlock(currEliteDiscountRate, isShowFullPrice, suppressDisplay);

  if (selectedCurrency.toLowerCase() !== DefaultValue) {
    priceInfo = resolveMonetaryDisplayBlock(currRate, isLocaleAllowed, suppressDisplay);
    totalPrice = resolveTotalPriceBlock(currRate, isShowFullPrice, suppressDisplay);
    EEOPriceInfo = suppressDisplay ? null : currEliteDiscountRate?.amount;
    EEOTotalPrice = resolveTotalPriceBlock(currEliteDiscountRate, isShowFullPrice, suppressDisplay);
    if (!searchResultAlerts.errorMessage && jsonContent?.alertsListArray) {
      setSearchResultAlerts(getAlertsData(jsonContent?.alertsListArray[2]?.alertCodeListModel[0], 'success'));
    }
  }

  const formatPrice = (block?: { amount?: number; decimalPoint?: number; currency?: string } | null) =>
    getPriceByDecimalPoint(
      block?.amount,
      block?.decimalPoint,
      searchState,
      currentLocaleVal,
      block?.currency,
      HQVRateConversionArr,
      HQVSelectedCurrency
    );

  const getCurrencyLabel = (rateCurrency?: string) =>
    selectedCurrency.toLowerCase() !== DefaultValue
      ? fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, selectedCurrency)
      : fetchCurrencyToLocale(currentLocale, staticContent?.currencyLabel, rateCurrency);

  const perNightCurrencyLabel = (rateCurrency?: string) =>
    `${getCurrencyLabel(rateCurrency)} ${staticContent?.perNightLabel}`;

  const applyStrikeThrough = (regular: any, eeo: any) => {
    if (!regular?.amount || !eeo?.amount || regular.amount <= eeo.amount) return;
    const show = checkThresholdPercentage(regular.amount, eeo.amount);
    setShowStrikeThroughPrice(show);
    setFinalPrice?.(formatPrice(eeo)?.toString());
  };

  if (currEliteDiscountRate) {
    if (totalPrice?.amount && EEOTotalPrice?.amount && totalPrice.amount > EEOTotalPrice.amount) {
      applyStrikeThrough(totalPrice, EEOTotalPrice);
    } else if (priceInfo?.amount && EEOPriceInfo?.amount && priceInfo.amount > EEOPriceInfo.amount) {
      applyStrikeThrough(priceInfo, EEOPriceInfo);
    }
  }

  const pointsSaverFlag = currPointSaversNode;

  useEffect(() => {
    let isHotelMaxOccupancyExceeded = false;
    let isHotelUnavailable = false;
    if (isErrorState) {
      if (
        !isFlexibleDateSearch &&
        (currRateNode?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED ||
          currRatePointsBlock?.status?.code === STATUS_MAX_OCCUPANCY_EXCEEDED)
      ) {
        isHotelMaxOccupancyExceeded = true;
      }

      if (
        !isFlexibleDateSearch &&
        !(currRateNode?.rateAmounts?.length || currRatePointsBlock?.rateAmounts?.length) &&
        propertyCardData?.node?.property?.basicInformation?.openingDate &&
        (currRateNode?.status?.code === STATUS_NOT_AVAILABLE ||
          currRatePointsBlock?.status?.code === STATUS_NOT_AVAILABLE)
      ) {
        isHotelUnavailable = true;
      }

      if (
        pointsValue ||
        totalPrice?.amount ||
        priceInfo?.amount ||
        isFlexibleDateSearch ||
        flexibleOrManyProperty ||
        isHotelMaxOccupancyExceeded ||
        isHotelUnavailable
      ) {
        setIsErrorState(false);
      }
    }
  }, []);

  const handleClick = () => {
    if (recentlyviewedRibbon && !HQVRateBlockFlag) {
      recentlyviewedRibbon(recentlyViewed, setRecentlyViewed, propertyID ? propertyID.toString() : ' ');
    }
  };

  const buildChatAvailabilityUrl = (propertyCode: string | number): string =>
    buildChatAvailabilityUrlUtil({
      baseUrl: addSubDirectoryPrefix(NEXT_PUBLIC_AVAILABILITY_SEARCH_URL ?? ''),
      propertyCode,
      chatSearchCriteria,
      fallbackSearchOptions: searchState?.search?.options,
      fallbackUseRewardsPoints: (searchState as any)?.points ?? false,
      fallbackFlexibleDate: isFlexibleDateSearch ?? false,
    });

  const getPriceLinkHref = () =>
    buildPriceLinkHref({
      pageVal,
      propertyID: propertyID ? propertyID.toString() : '',
      chatHref: buildChatAvailabilityUrl(propertyID),
      availabilitySearchUrl: NEXT_PUBLIC_AVAILABILITY_SEARCH_URL,
      isShowFullPrice,
      selectedCurrency,
    });

  const { isResort, isLACountyFee, isMarketingFee, isDestinationFee } = identifyTypeOfMandatoryFee(
    propertyCardData?.node?.property?.basicInformation
  );
  const { toolTipTitle } = constructToolTipData(
    isResort,
    isLACountyFee,
    isMarketingFee,
    isDestinationFee,
    staticContent
  );

  const isMandatoryFeeAvailable = mandatoryFeeAvailable(
    currRate,
    isLocaleAllowed,
    flexibleOrManyProperty ? true : false
  );
  const isStrikethroughMandatoryFee = mandatoryFeeAvailable(currRate, isLocaleAllowed, isFlexibleDateSearch);
  const getMandatoryFeeDescription = () =>
    mandatoryFeeDescriptionForPoints(
      mandatoryFeeRates,
      searchQueryState,
      currentLocale,
      propertyCardData,
      staticContent,
      selectedCurrency,
      HQVRateConversionArr,
      HQVSelectedCurrency,
      pointsSaverFlag,
      currentViewIsTab,
      HQVRateBlockFlag
    );
  const tooltipSubheading = toolTipTitle + ' ' + staticContent?.includesLabel + ':';

  const mandatoryFeeSectionProps = {
    mandatoryFeeDescription: getMandatoryFeeDescription(),
    isMarketingFee,
    staticContent,
    currentViewIsTab,
    isMapViewEnabled,
    currentViewIsMobile,
    fromHotelCard,
    HQVRateBlockFlag,
    pointsSaverFlag,
    toolTipList,
    handleTooltipClick,
    clickTrackingLoc,
    tooltipSubheading,
  };

  const rateContainerClick = () =>
    updateDatalayerObjViewRates(searchResult, pageNumber, idx, isFlexibleDateSearch, HQVRateBlockFlag);

  return (
    <StyledPropertyCardPriceDiv>
      {
        <div
          role="term"
          tabIndex={-1}
          {...(HQVRateBlockFlag
            ? { className: 'hqv-price-component' }
            : { className: 'analytics-click custom_click_track property-card-price-component' })}
          {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
        >
          {pointsValue ? (
            <div
              className={clsx(HQVRateBlockFlag ? 'hqv-rate-container' : '', 'rate-container')}
              data-testid={'pointscard-testid'}
              onClick={rateContainerClick}
            >
              <div
                className={clsx(
                  'points-section',
                  HQVRateBlockFlag && 'ml-3 hqv-modal-points-styling',
                  pointsSaverFlag ? 'points-saver' : 'non-saver',
                  isDePointsLayout() ? 'points-de-section' : ''
                )}
              >
                {pointsSaverFlag && (
                  <div
                    className={clsx(
                      currentViewIsTab && isMapViewEnabled ? 'mb-n1' : '',
                      't-label-alt-xs points-saver-label text-left'
                    )}
                  >
                    {staticContent?.pointsSaverLabel}
                  </div>
                )}
                <PropertyCardPriceLink
                  testId="propertycard-testid-points"
                  href={getPriceLinkHref()}
                  onClick={handleClick}
                  HQVRateBlockFlag={HQVRateBlockFlag}
                  pageVal={pageVal}
                  clickTrackingLoc={clickTrackingLoc}
                >
                  <div
                    className={clsx(
                      (currentLocale === 'ru-RU' || currentLocale === 'pt-BR') &&
                        !HQVRateBlockFlag &&
                        (currentViewIsMobile || currentViewIsTab || (currentViewIsDesktop && isMapViewEnabled))
                        ? 'ru-specific-price-section'
                        : 'price-section',
                      currentViewIsDesktop && isMapViewEnabled ? 'price-section-map-view' : '',
                      isPointsExceeds ? (!currentViewIsMobile ? 'd-block' : !isMapViewEnabled ? 'd-block' : '') : '',
                      (pointsSaverFlag && !HQVRateBlockFlag) || (totalPrice?.amount && HQVRateBlockFlag)
                        ? 'justify-content-start'
                        : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : '',
                      isDeMapListSection() ? 'points-value-de-section' : ''
                    )}
                  >
                    <div
                      className={clsx(
                        'm-price points-value',
                        currentLocale === 'ru-RU' &&
                          !HQVRateBlockFlag &&
                          (currentViewIsMobile || currentViewIsTab || (currentViewIsDesktop && isMapViewEnabled))
                          ? 'ru-specific-line-height'
                          : '',
                        pointsSaverFlag ? `points-saver` : ``,
                        isDeMapListSection() ? 'points-value-de' : ''
                      )}
                    >
                      {getPriceCommaSeparator(pointsValue, searchState, currentLocaleVal, HQVSelectedCurrency)}
                    </div>
                    <div
                      className={clsx(
                        pointsSaverFlag ? `t-label-xs` : `t-label-alt-xs`,
                        'points-currency-label',
                        isDeMapListSection() ? 'points-value-de-label' : ''
                      )}
                      {...(HQVRateBlockFlag ? {} : { role: 'button' })}
                    >
                      {staticContent?.pointsPerStayLabel}
                    </div>
                  </div>
                </PropertyCardPriceLink>
                {isMandatoryFeeAvailable &&
                toolTipTitle !== '' &&
                !totalPrice?.amount &&
                !(isLACountyFee || isMarketingFee) &&
                (currentViewIsTab || (!currentViewIsTab && !fromHotelCard)) ? (
                  <PointsMandatoryFeeSection marginVariant="standalone" {...mandatoryFeeSectionProps} />
                ) : (
                  <></>
                )}
                {totalPrice?.amount ? (
                  <div
                    className={clsx(
                      'd-flex flex-column currency-section m-price-currency-s t-font-alt-s ',
                      isDeMapListSection() ? 'points-de-currency-section' : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : '',
                      currentViewIsTab &&
                        !currentViewIsDesktop &&
                        !currentViewIsMobile &&
                        isMapViewEnabled &&
                        'align-items-start'
                    )}
                  >
                    {isMandatoryFeeAvailable &&
                    toolTipTitle !== '' &&
                    !(isLACountyFee || isMarketingFee) &&
                    priceInfo?.amount ? (
                      <>
                        <PointsMandatoryFeeSection marginVariant="withTotalPrice" {...mandatoryFeeSectionProps} />
                        <div
                          className={clsx(
                            'currency-section m-price-currency-s',
                            isDeMapListSection() ? 'points-de-currency-section' : '',
                            !HQVRateBlockFlag && (isMapViewEnabled || currentViewIsTab)
                              ? 'price-section-map-view-max-width'
                              : '',
                            pointsSaverFlag ? 'justify-content-start text-left' : ''
                          )}
                        >
                          <div
                            className={clsx('t-font-alt-xs', 'price-value', currentViewIsTab ? 'text-ellipsis' : '')}
                          >
                            {formatPrice(totalPrice)}
                            {` ${getCurrencyLabel(totalPrice?.currency)} ${
                              staticContent?.perNightLabel
                            } ${staticContent?.includesLabel?.toLowerCase()}  ${staticContent?.taxesAndFeesLabel?.toLowerCase()}`}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={clsx('d-flex', 'price-section-color', 'price-value-section')}>
                          <div className={clsx(pointsSaverFlag ? `t-font-xs` : `t-font-alt-xs`, 'price-value')}>
                            {formatPrice(totalPrice)}
                          </div>
                          <div
                            className={clsx(
                              pointsSaverFlag ? `t-font-xs` : `t-font-alt-xs`,
                              ' currency-label',
                              HQVTaxesandFeeFlag ? 'taxes-currency-label' : ''
                            )}
                            tabIndex={0}
                            {...(HQVRateBlockFlag ? {} : { role: 'button' })}
                          >
                            {perNightCurrencyLabel(totalPrice?.currency)}
                          </div>
                        </div>
                        <TaxesAndFeesIncludedLabel
                          show={(!currentViewIsTab && !fromHotelCard) || currentViewIsTab}
                          currentViewIsTab={currentViewIsTab}
                          fromHotelCard={fromHotelCard}
                          label={staticContent?.taxesAndFeesIncluded}
                          isAlignItemStart={
                            currentViewIsTab && !currentViewIsDesktop && !currentViewIsMobile && isMapViewEnabled
                          }
                        />
                      </>
                    )}
                  </div>
                ) : (
                  ''
                )}
                {priceInfo?.amount && !totalPrice?.amount ? (
                  <div
                    className={clsx(
                      'currency-section m-price-currency-s',
                      isDeMapListSection() ? 'points-de-currency-section' : '',
                      !HQVRateBlockFlag && (isMapViewEnabled || currentViewIsTab)
                        ? 'price-section-map-view-max-width'
                        : '',
                      pointsSaverFlag ? 'justify-content-start text-left' : ''
                    )}
                  >
                    <div
                      className={clsx(`t-font-alt-xs`, 'm-price-currency-s', currentViewIsTab ? 'text-ellipsis' : '')}
                    >
                      {formatPrice(priceInfo)}{' '}
                      {`${getCurrencyLabel(priceInfo?.currency)} ${staticContent?.perNightLabel} 
                      ${
                        isMandatoryFeeAvailable && toolTipTitle !== ''
                          ? `${staticContent?.includesLabel?.toLowerCase()} ${staticContent?.dailyLabel?.toLowerCase()} ${staticContent?.feeLabel?.toLowerCase()}`
                          : ''
                      } 
                      `}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          ) : (
            ''
          )}

          {!pointsValue && totalPrice?.amount ? (
            <PropertyCardPriceLink
              testId="propertycard-testid-taxes"
              href={getPriceLinkHref()}
              onClick={handleClick}
              HQVRateBlockFlag={HQVRateBlockFlag}
              pageVal={pageVal}
              clickTrackingLoc={clickTrackingLoc}
            >
              <div
                className={clsx(
                  HQVRateBlockFlag ? 'hqv-rate-container' : '',
                  'rate-container',
                  !isMapViewEnabled && currentViewIsDesktop && 'ml-0'
                )}
                onClick={rateContainerClick}
              >
                <StrikeThroughPriceDisplay
                  variant="taxes"
                  displayBlock={totalPrice}
                  eeoBlock={EEOTotalPrice}
                  longPriceCheckBlock={priceInfo}
                  eeoAriaCurrency={EEOPriceInfo?.currency}
                  showStrikeThroughPrice={showStrikeThroughPrice}
                  fromHotelCard={fromHotelCard}
                  isMapViewEnabled={isMapViewEnabled}
                  HQVRateBlockFlag={HQVRateBlockFlag}
                  HQVTaxesandFeeFlag={HQVTaxesandFeeFlag}
                  staticContent={staticContent}
                  formatPrice={formatPrice}
                  perNightCurrencyLabel={perNightCurrencyLabel}
                  isStrikethroughMandatoryFee={Boolean(isStrikethroughMandatoryFee)}
                  isDeMapListSection={isDeMapListSection()}
                  isViewportL={isViewportL}
                  includeTaxesAndFees={searchState?.includeTaxesAndFees}
                  currentViewIsTab={currentViewIsTab}
                  currentViewIsMobile={currentViewIsMobile}
                />
              </div>
            </PropertyCardPriceLink>
          ) : (
            ''
          )}
          {!pointsValue && !totalPrice?.amount && priceInfo?.amount ? (
            <PropertyCardPriceLink
              testId="propertycard-testid-cash"
              href={getPriceLinkHref()}
              onClick={handleClick}
              HQVRateBlockFlag={HQVRateBlockFlag}
              pageVal={pageVal}
              clickTrackingLoc={clickTrackingLoc}
            >
              <div
                className={clsx(
                  HQVRateBlockFlag ? 'hqv-rate-container' : '',
                  'rate-container',
                  !isMapViewEnabled && currentViewIsDesktop && 'ml-0'
                )}
                onClick={rateContainerClick}
              >
                <StrikeThroughPriceDisplay
                  variant="cash"
                  displayBlock={priceInfo}
                  eeoBlock={EEOPriceInfo}
                  longPriceCheckBlock={priceInfo}
                  showStrikeThroughPrice={showStrikeThroughPrice}
                  fromHotelCard={fromHotelCard}
                  isMapViewEnabled={isMapViewEnabled}
                  currentLocale={currentLocale}
                  currentViewIsMobile={currentViewIsMobile}
                  currentViewIsTab={currentViewIsTab}
                  HQVRateBlockFlag={HQVRateBlockFlag}
                  selectedCurrency={selectedCurrency}
                  staticContent={staticContent}
                  formatPrice={formatPrice}
                  perNightCurrencyLabel={perNightCurrencyLabel}
                  isStrikethroughMandatoryFee={Boolean(isStrikethroughMandatoryFee)}
                />
              </div>
            </PropertyCardPriceLink>
          ) : (
            ''
          )}

          {!pointsValue && !totalPrice?.amount && !priceInfo?.amount && !flexibleSearch && !flexibleOrManyProperty ? (
            <PropertyCardPriceLink
              testId="propertycard-testid-unavailable"
              href={getPriceLinkHref()}
              onClick={handleClick}
              HQVRateBlockFlag={HQVRateBlockFlag}
              pageVal={pageVal}
              clickTrackingLoc={clickTrackingLoc}
            >
              <div
                className={clsx('t-label-xs', 'currency-label', 'rate-unavailable')}
                tabIndex={0}
                {...(HQVRateBlockFlag ? {} : { role: 'button' })}
              >
                {fromHotelCard
                  ? isSpecialRateSearch
                    ? jsonContent.rateUnavailableLabel
                    : jsonContent?.soldOutLabel
                  : staticContent?.rateUnavailableLabel}
              </div>
            </PropertyCardPriceLink>
          ) : (
            ''
          )}
          {(flexibleSearch || flexibleOrManyProperty) && (
            <div className={clsx('t-label-xs', 'currency-label', 'rate-unavailable')}></div>
          )}
        </div>
      }
    </StyledPropertyCardPriceDiv>
  );
};
